"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Item = require("./Item.Styled");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Item = _ref => {
  let {
    title,
    content,
    open,
    toggle,
    id
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Item.StyledItem, {
    id: id
  }, /*#__PURE__*/_react.default.createElement(_Item.Header, {
    onClick: toggle
  }, /*#__PURE__*/_react.default.createElement(_Item.Title, null, title), /*#__PURE__*/_react.default.createElement(_Item.OpenIcon, null, open ? '▼' : '▲')), open && /*#__PURE__*/_react.default.createElement(_Item.Body, null, content));
};

var _default = Item;
exports.default = _default;